import React from 'react';

type ErrorBoundaryProps = {
  ErrorPage: () => JSX.Element;
  onError?: (error: string, errorInfo: string) => void;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { onError } = this.props;
    if (onError) {
      onError(error, JSON.stringify(errorInfo));
    }
  }

  render() {
    const { hasError } = this.state;
    const { children, ErrorPage } = this.props;
    if (hasError) {
      return <ErrorPage />;
    }

    return children;
  }
}

export default ErrorBoundary;
